export default __webpack_public_path__ + "static/callout_personal_3_img_0-aa12264649f9759e5c7c4fa2b013c5d4.png";